import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-00550f9e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "-title-rounded-h" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Upgrade yourself")
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Anywhere, anytime. Start learning today! And Get an Exceptional Education Experience. ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-h4 py-4 -title-1" }, "Popular Courses", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "text-h4 py-4 -title-1" }, "Explore More Courses", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_cmp_carousel = _resolveComponent("cmp-carousel")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_cmp_info_card = _resolveComponent("cmp-info-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_cmp_explore_card = _resolveComponent("cmp-explore-card")!
  const _component_v_tabs_window_item = _resolveComponent("v-tabs-window-item")!
  const _component_v_tabs_window = _resolveComponent("v-tabs-window")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_cmp_carousel, { images: _ctx.carouselImages }, null, 8, ["images"]),
    _createVNode(_component_v_container, { class: "upgrade-yourself-container" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, {
          class: "upgrade-yourself-card",
          variant: "flat"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, { class: "content" }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_container, null, {
      default: _withCtx(() => [
        _hoisted_3,
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courses, (course) => {
              return (_openBlock(), _createBlock(_component_v_col, {
                cols: "12",
                sm: "6",
                md: "6",
                lg: "3",
                key: course.title
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_cmp_info_card, {
                    image: course.image,
                    title: course.title,
                    subtitle: course.subtitle,
                    text: course.text,
                    cssClass: course.color,
                    courseId: course.courseId
                  }, null, 8, ["image", "title", "subtitle", "text", "cssClass", "courseId"])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_container, null, {
      default: _withCtx(() => [
        _hoisted_4,
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_tabs, {
              modelValue: _ctx.tab,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tab) = $event)),
              "align-tabs": "start",
              color: "deep-purple-accent-4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_tab, {
                  href: "javascript:void(0)",
                  value: "tab1"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Web Development")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_tab, {
                  href: "javascript:void(0)",
                  value: "tab2"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Cloud and Dev-Ops")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_tab, {
                  href: "javascript:void(0)",
                  value: "tab3"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Cyber Security")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_tab, {
                  href: "javascript:void(0)",
                  value: "tab4"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Databases")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_tab, {
                  href: "javascript:void(0)",
                  value: "tab5"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("AI/ML and Robotics")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_tab, {
                  href: "javascript:void(0)",
                  value: "tab6"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("General Programming and Skills")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_tabs_window, {
                  modelValue: _ctx.tab,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tab) = $event))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (n) => {
                      return _createVNode(_component_v_tabs_window_item, {
                        key: n,
                        value: `tab${n}`
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_container, { fluid: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_row, null, {
                                default: _withCtx(() => [
                                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (i) => {
                                    return _createVNode(_component_v_col, {
                                      key: i,
                                      cols: "12",
                                      md: "4"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_cmp_explore_card, {
                                          title: "Architect",
                                          description: "Nulla lobortis nunc vitae nisi semper semper.",
                                          image: `https://picsum.photos/500/300?image=${
                      i * n * 5 + 10
                    }`,
                                          link: "#"
                                        }, null, 8, ["image"])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  }), 64))
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["value"])
                    }), 64))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}